module.exports = __webpack_public_path__ + "static/media/usps.1a127615.png";